module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "添加订单",
      "width": "700"
    },
    model: {
      value: (_vm.editModal),
      callback: function($$v) {
        _vm.editModal = $$v
      },
      expression: "editModal"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRule
    }
  }, [_c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型",
      "prop": "channel"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.loadCoursePackageTypeData2
    },
    model: {
      value: (_vm.formData.channel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "channel", _vm._n($$v))
      },
      expression: "formData.channel"
    }
  }, _vm._l((_vm.$constant.orderChannelNew), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "on-blur": _vm.inputMobile
    },
    model: {
      value: (_vm.formData.uid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "uid", _vm._n($$v))
      },
      expression: "formData.uid"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.formData.channel === 1) ? _c('Row', [_c('i-col', {
    attrs: {
      "span": 12,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "介绍人",
      "prop": "inviteId",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "介绍人学生ID"
    },
    model: {
      value: (_vm.formData.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inviteId", _vm._n($$v))
      },
      expression: "formData.inviteId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "转介绍课时",
      "prop": "inviteClassHour",
      "required": ""
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "上满一个月后系统系统会自动赠送"
    },
    model: {
      value: (_vm.formData.inviteClassHour),
      callback: function($$v) {
        _vm.$set(_vm.formData, "inviteClassHour", _vm._n($$v))
      },
      expression: "formData.inviteClassHour"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "转介绍凭证",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 200,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formData.url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "url", $$v)
      },
      expression: "formData.url"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', [_c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "contractName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "选填"
    },
    model: {
      value: (_vm.formData.contractName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractName", $$v)
      },
      expression: "formData.contractName"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型：",
      "prop": "tchChannel"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.loadCoursePackageTypeData
    },
    model: {
      value: (_vm.formData.tchChannel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tchChannel", $$v)
      },
      expression: "formData.tchChannel"
    }
  }, _vm._l((_vm.$constant.tchChannel), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 23,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课时数量明细",
      "prop": "courseType"
    }
  }, [_c('Select', {
    key: _vm.packageSelectKey,
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.onCourseTypeChange
    },
    model: {
      value: (_vm.formData.courseType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "courseType", $$v)
      },
      expression: "formData.courseType"
    }
  }, _vm._l((_vm.courseScheduleListData), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠送课时",
      "prop": "discountNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "赠送课时数"
    },
    on: {
      "input": _vm.calculateLeaveNum
    },
    model: {
      value: (_vm.formData.discountNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discountNum", _vm._n($$v))
      },
      expression: "formData.discountNum"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠金额",
      "prop": "discount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "优惠金额"
    },
    on: {
      "input": _vm.calculatePayAmount
    },
    model: {
      value: (_vm.formData.discount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discount", _vm._n($$v))
      },
      expression: "formData.discount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 23,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠说明",
      "prop": "discountRemark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "有优惠时必填"
    },
    model: {
      value: (_vm.formData.discountRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "discountRemark", _vm._n($$v))
      },
      expression: "formData.discountRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单原价",
      "prop": "amount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    on: {
      "input": _vm.calculatePayAmount
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", _vm._n($$v))
      },
      expression: "formData.amount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "优惠价",
      "prop": "amount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填"
    },
    model: {
      value: (_vm.formData.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "payAmount", _vm._n($$v))
      },
      expression: "formData.payAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分笔："
    }
  }, [_c('Checkbox', {
    model: {
      value: (_vm.formData.hasTwoPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "hasTwoPay", $$v)
      },
      expression: "formData.hasTwoPay"
    }
  }, [_vm._v("分笔付款")])], 1)], 1), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('InputNumber', {
    attrs: {
      "max": 3,
      "min": 2
    },
    on: {
      "on-change": _vm.zero
    },
    model: {
      value: (_vm.formData.twoPayNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "twoPayNum", _vm._n($$v))
      },
      expression: "formData.twoPayNum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "首笔款:",
      "prop": "firstPay",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不得少于1000"
    },
    on: {
      "on-change": _vm.calculate
    },
    model: {
      value: (_vm.formData.firstPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "firstPay", _vm._n($$v))
      },
      expression: "formData.firstPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.twoPayNum === 3) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "二笔款:",
      "prop": "secondPay",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不得少于1000"
    },
    on: {
      "on-change": _vm.calculate
    },
    model: {
      value: (_vm.formData.secondPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "secondPay", _vm._n($$v))
      },
      expression: "formData.secondPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.hasTwoPay === true) ? _c('i-col', {
    attrs: {
      "span": 5,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "尾款:",
      "prop": "",
      "label-width": 55
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.lastPay),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lastPay", _vm._n($$v))
      },
      expression: "formData.lastPay"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "报名加赠课时",
      "prop": "giveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.giveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "giveNum", _vm._n($$v))
      },
      expression: "formData.giveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 1) ? _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "请假次数",
      "prop": "leaveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.leaveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveNum", _vm._n($$v))
      },
      expression: "formData.leaveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抵消课机会",
      "prop": "leaveNum"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.leaveNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "leaveNum", _vm._n($$v))
      },
      expression: "formData.leaveNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 1) ? _c('i-col', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "补课次数"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.makeupLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeupLessonNum", _vm._n($$v))
      },
      expression: "formData.makeupLessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.formData.tchChannel === 2) ? _c('i-col', {
    attrs: {
      "span": 20,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "24小时内取消课机会"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "207px"
    },
    attrs: {
      "placeholder": "必填",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.makeupLessonNum),
      callback: function($$v) {
        _vm.$set(_vm.formData, "makeupLessonNum", _vm._n($$v))
      },
      expression: "formData.makeupLessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "编辑合同",
      "prop": "contractVersionId"
    }
  }, [_c('Select', {
    attrs: {
      "placement": "top",
      "filterable": ""
    },
    on: {
      "on-change": _vm.onChangeSelectContractVersion
    },
    model: {
      value: (_vm.formData.contractVersionId),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractVersionId", $$v)
      },
      expression: "formData.contractVersionId"
    }
  }, _vm._l((_vm.versionList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.showDealMonth) ? _c('i-col', {
    attrs: {
      "span": 11,
      "offset": 1
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "成交月份",
      "prop": "dealMonth"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择成交月份",
      "transfer": ""
    },
    model: {
      value: (_vm.formData.dealMonth),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dealMonth", $$v)
      },
      expression: "formData.dealMonth"
    }
  }, _vm._l((_vm.dealMonthOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onInsert
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67109b4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/AddOrderModal.vue
// module id = 1863
// module chunks = 8